import { render, staticRenderFns } from "./Greenn.vue?vue&type=template&id=2f994c72&"
import script from "./Greenn.vue?vue&type=script&lang=js&"
export * from "./Greenn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports